// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'virtualWaitingRoom.call.continueButton': "Let's Go",
  'virtualWaitingRoom.call.invitationMessage': 'Invited you to join a video call',
  'virtualWaitingRoom.call.rejoinCallFloatingButtonText': 'Rejoin call',
  'virtualWaitingRoom.intakeForm.defaultWelcomeMessage': 'Welcome to our Virtual Waiting Room!',
  'virtualWaitingRoom.intakeForm.errorMessage': 'Sorry an error occurred, please try again.',
  'virtualWaitingRoom.intakeForm.firstNameLabel': 'FIRST NAME (required)',
  'virtualWaitingRoom.intakeForm.firstNamePlaceholder': 'First',
  'virtualWaitingRoom.intakeForm.lastNameLabel': 'LAST NAME (required)',
  'virtualWaitingRoom.intakeForm.lastNamePlaceholder': 'Last',
  'virtualWaitingRoom.intakeForm.phoneErrorMessage': 'Invalid phone number',
  'virtualWaitingRoom.intakeForm.phoneLabel': 'MOBILE PHONE NUMBER (required)',
  'virtualWaitingRoom.intakeForm.reasonSelectorLabel': 'REASON FOR VISIT (required)',
  'virtualWaitingRoom.intakeForm.reasonDefaultOption': 'Select Your Option',
  'virtualWaitingRoom.intakeForm.reasonScheduledOption': 'Scheduled',
  'virtualWaitingRoom.intakeForm.reasonWalkInOption': 'Walk-In',
  'virtualWaitingRoom.intakeForm.reasonGeneralInquiryOption': 'General Inquiry',
  'virtualWaitingRoom.intakeForm.EULACopy':
    'By checking this box you are consenting to receiving SMS messages. Fees and rates will apply. For more information tap ',
  'virtualWaitingRoom.intakeForm.EULALink':
    'https://v4-web-static.s3.amazonaws.com/hosted/eula/v2/tigertouch-eula-v2.0/eula.pdf',
  'virtualWaitingRoom.intakeForm.EULALinkText': 'End User License Agreement',
  'virtualWaitingRoom.intakeForm.nextButton': 'Next',
  'virtualWaitingRoom.invalidRoomHeader': 'Invalid Link',
  'virtualWaitingRoom.invalidRoomSubheader':
    'This room does not exist. Please contact your provider.',
  'virtualWaitingRoom.sessionEndedHeader': 'Your Virtual Waiting Room Session Has Ended',
  'virtualWaitingRoom.sessionEndedSubheader':
    'You have a great day and you may close this browser at any time. Thank you.',
  'virtualWaitingRoom.roomClosedHeader': 'Virtual Waiting Room is Currently Closed',
  'virtualWaitingRoom.roomClosedSubheader':
    'Please try again later. If this is an emergency, please call 911',
  'virtualWaitingRoom.visitForm.invalidLastName': 'Invalid last name, please try again.',
  'virtualWaitingRoom.visitForm.lastNameLabel': 'Enter Your Last Name',
  'virtualWaitingRoom.visitForm.lastNamePlaceholder': 'Last Name',
  'virtualWaitingRoom.visitForm.nextButton': 'Next',
};
